module.exports = __webpack_public_path__ + "media/hero_vb9_720.3bbe7498.webm";